import { css } from '@emotion/react'
import colors from '@mathflat/common/style/colors'

const S = {
  input: css`
    display: none;

    &:disabled + label {
      cursor: auto;
      color: ${colors.gray.$600};
      border: 1px solid ${colors.gray.$200};
      background: #fff;
    }

    &:checked:not(:disabled) + label {
      border: solid 1px var(--Colors-Green-200);
      background-color: var(--Colors-Green-50);
      color: var(--Colors-Green-500);
    }

    &:checked:disabled + label {
      border: solid 1px var(--Colors-Green-200);
      background-color: var(--Colors-Green-50);
      color: var(--Colors-Green-500);
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  label: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9px 12px;
    border: 1px solid ${colors.borderColor};
    border-radius: var(--Radius-100);
    color: ${colors.gray.$700};
    background-color: white;
    white-space: pre;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &.rounded {
      padding: 8px 16px;
      border-radius: var(--Radius-Circle);
    }

    &:hover {
      background-color: ${colors.gray.$100};
    }
  `,
}

export default S
